import httpClient from '@/http-client'
import config from '../config'

export const get = (options = {}) => {
  return httpClient
    .get(`${config.apiPrefix}/product-categories`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get }
